
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M22 3c-3.3 0-6 2.7-6 6 0 .992.383 2.004.875 3.125a34.951 34.951 0 001.75 3.406 61.616 61.616 0 002.563 4.033L22 20.75l.813-1.188s1.29-1.835 2.562-4.03a35.08 35.08 0 001.75-3.407C27.617 11.005 28 9.992 28 9c0-3.3-2.7-6-6-6zM11.97 4.938L4 8.344V27.53l8.03-3.468 8 3L28 23.657v-8.718a49.5 49.5 0 01-2 3.437v3.97l-5 2.124v-1.626l-1.47-2.125c-.155-.228-.34-.497-.53-.782v4.625l-6-2.25V7.438l1.094.406a7.867 7.867 0 01.53-1.938zM22 5c2.22 0 4 1.78 4 4 0 .387-.242 1.3-.688 2.313-.445 1.01-1.074 2.16-1.687 3.218-.816 1.408-1.168 1.908-1.625 2.595-.457-.688-.81-1.188-1.625-2.594-.613-1.057-1.242-2.206-1.688-3.217C18.242 10.3 18 9.386 18 9c0-2.22 1.78-4 4-4zM11 7.5v14.844L6 24.47V9.655zm11 0a1.5 1.5 0 10.001 3.001A1.5 1.5 0 0022 7.5z"}})])
          )
        }
      }
    